<template>
<v-container class="py-0">
  <v-row wrap>
    <v-col cols="6" class="py-1">
      <DisplayField label="Policy" :value="policyTitle" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Status" :value="policy.calculatedStatus" />
    </v-col>
    <v-col cols="12" class="py-1">
      <DisplayField label="Carrier" :value="policy.carrier" />
    </v-col>
    <v-col cols="12" class="py-1">
      <DisplayField label="Program" :value="policy.program" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Eff. Date" :value="policy.effectiveDate" type="date" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Exp. Date" :value="policy.expirationDate" type="date" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Current Rate" :value="policy.currentPremium" type="currency" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Annualized Premium" :value="policy.annualizedPremium" type="currency" />
    </v-col>
  </v-row>

  <template v-if="viewingMore">
    <v-divider />

    <v-row class="py-2">
      <v-col cols="6" class="py-1">
        <DisplayField label="Policy #" :value="policy.policyNumber" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Application Type" :value="policyApplicationTypes[policy.applicationType]" />
      </v-col>
    </v-row>

    <v-divider />

    <v-row class="py-2">
      <v-col cols="6" class="py-1">
        <DisplayField label="Term" :value="policy.term" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Status Date" :value="policy.statusDate" type="date" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Inception Date" :value="policy.inceptionDate" type="date" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Sold Date" :value="policy.soldDate" type="date" />
      </v-col>
    </v-row>

    <v-divider />

    <v-row class="py-2">
      <v-col cols="4" class="py-2">
        <DisplayField label="Agent 1" :value="policy.agent1" />
      </v-col>

      <v-col cols="4" class="py-2">
        <DisplayField label="Agent 2" :value="policy.agent2" />
      </v-col>

      <v-col cols="4" class="py-2">
        <DisplayField label="Agent 3" :value="policy.agent3" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Agent Code" :value="policy.agentCode" />
      </v-col>

      <v-col v-if="policy && policy.officeName" cols="6" class="py-1">
        <DisplayField label="Office" :value="policy.officeName" />
      </v-col>

      <v-col cols="12" class="py-1">
        <DisplayField label="Source" :value="policy.source" />
      </v-col>
    </v-row>

    <v-divider />

    <v-row class="pt-2">
      <v-col cols="12" class="py-1">
        <DisplayField label="Billing Plan" :value="billingPlans[policy.billingPlan]" />
      </v-col>

      <v-col cols="12" class="py-1">
        <DisplayField label="Payment Plan" :value="policy.paymentPlan" />
      </v-col>

      <v-col cols="6" class="py-1">
        <DisplayField label="Quoted Premium" :value="policy.quotedPremium" type="currency" />
      </v-col>
    </v-row>
  </template>
  <v-row justify="end">
    <v-col cols="6" class="text-end">
      <a class="link" @click="toggleView">
        {{ viewMoreText }}
      </a>
    </v-col>
  </v-row>
</v-container>
</template>

<style>
  .tileSheet {
    justify-content: center;
    align-items: center;
  }
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'Policies',
  components: {
    DisplayField
  },
  props: {
    policy: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      viewingMore: false,
      policyApplicationTypes: {
        0: 'Other',
        65: 'Agricultural',
        67: 'Commercial',
        72: 'Health',
        76: 'Life',
        80: 'Personal',
        83: 'Surety Bond'
      },
      billingPlans: {
        0: '',
        1: 'Direct Bill',
        2: 'Agency Bill',
        3: 'Premium Finance',
        4: 'Direct Bill EFT',
        5: 'Mortgagee Bill',
        6: 'Escrow Bill',
        7: 'Self-Reporting Payroll'
      }
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    policyTitle: function () {
      if ((this.policy || null) === null) {
        return '';
      }
      return `${this.policy.displayOrder + 1}-${this.policy.title}`;
    }
  },
  methods: {
    toggleView: function () {
      if (!this.viewingMore) {
        analyticsService.sendEvent(this.$gtag, 'View More', 'Policy', 'Policy Info View More');
      }
      this.viewingMore = !this.viewingMore;
    }
  }
};
</script>
